import {
  Accordion,
  AccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Typography,
  withStyles,
} from '@material-ui/core';
import { ContentWrapperWidget, MainTemplate } from '../../components/layouts';
import {
  CreateNewTrainerMutationHookResult,
  CreateTrainerMutationHookResult,
  useCreateNewTrainerMutation,
  useCreateTrainerMutation,
  useTrainerByIdLazyQuery,
} from '../../api';
import React, { ChangeEvent, FC, useEffect, useState } from 'react';

import AdditionalInfo from '../../components/widgets/Persons/AdditionalInfo';
import Duplicates from '../../components/widgets/Persons/Duplicates';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MainInfo from '../../components/widgets/Persons/MainInfo';
import Organizations from '../../components/widgets/Trainers/Organizations';
import TypeSports from '../../components/widgets/Trainers/TypeSports';
import _get from 'lodash/get';
import { blue } from '@material-ui/core/colors';
import moment from 'moment';
import onExpand from '../../utils/onExpand';
import { useHistory } from 'react-router';
import { usePermission } from '../../hooks/usePermission';
import { useRouteMatch } from 'react-router-dom';

type AccordionTypes = 'MainInfo' | 'Organizations' | 'TypeSports' | 'AdditionalInfo' | 'Duplicates' | undefined;

const AccordionSummary = withStyles({
  root: {
    backgroundColor: blue[700],
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    color: 'white',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary) as any;

// @TODO: Update View for Dialog request to Archive

const Single: FC<{}> = () => {
  const {
    params: { id },
  } = useRouteMatch();
  // const [page, setPage] = useState<number>(0);
  const { push } = useHistory();

  const [expanded, setExpanded] = useState<AccordionTypes>('MainInfo');
  const access = usePermission('directory', 'trainers');
  // const access = usePermission('directory', 'person');
  // const style = useStyle();
  // const canAdd = true;
  const [fetch, { data, loading }] = useTrainerByIdLazyQuery({ variables: { id } });
  const [create]: CreateNewTrainerMutationHookResult = useCreateNewTrainerMutation();
  const handleChangeAccordion = (panel: AccordionTypes) => (event: ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : undefined);
  };
  const OptionTitleArchive = data?.dirTrainer?.archive
    ? ` (В архиве с ${moment(data?.dirTrainer?.archive?.date).format('DD.MM.YYYY')})`
    : '';

  useEffect(() => {
    if (id !== 'new' && id !== '') {
      fetch({ variables: { id } });
    }
  }, [fetch, id]);

  return (
    <MainTemplate
      pageName=""
      url=""
      title={
        id === 'new'
          ? 'Добавить нового тренера'
          : `Тренер: ${data?.dirTrainer?.dirPerson?.lastname} ${data?.dirTrainer?.dirPerson?.firstname} ${
              data?.dirTrainer?.dirPerson?.patronymic || ''
            }`
      }
    >
      <ContentWrapperWidget>
        {id === 'new' ? (
          <h2>Добавить нового тренера</h2>
        ) : (
          <h2>
            {`Реестровый номер: ${data?.dirTrainer?.dirPerson?.registryNumber || ''} , `}
            Тренер: {data?.dirTrainer?.dirPerson?.lastname} {data?.dirTrainer?.dirPerson?.firstname}{' '}
            {`${_get(data?.dirTrainer?.dirPerson, 'patronymic', '') || ''} `}
            {moment(data?.dirTrainer?.dirPerson?.birthday).format('DD.MM.YYYY')}
            {OptionTitleArchive}
          </h2>
        )}
        <Accordion expanded={expanded === 'MainInfo'} onChange={handleChangeAccordion('MainInfo')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Общая информация</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, 'MainInfo') && (
              <MainInfo
                id={data?.dirTrainer?.dirPerson?.id || 'new'}
                isTrainer
                onUpdate={async (idPerson, sportType) => {
                  if (id === 'new') {
                    const trainer = await create({ variables: { idPerson, sportType } });
                    push(`/trainer/${trainer?.data?.createDirTrainer?.id}`);
                  }
                }}
                readonly={!access.includes(2)}
              />
            )}
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'AdditionalInfo'}
          onChange={handleChangeAccordion('AdditionalInfo')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Контактная информация</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, 'AdditionalInfo') && data?.dirTrainer?.dirPerson?.id && (
              <AdditionalInfo id={data?.dirTrainer?.dirPerson.id} readonly={!access.includes(2)} />
            )}
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'TypeSports'}
          onChange={handleChangeAccordion('TypeSports')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Виды спорта</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, 'TypeSports') && data?.dirTrainer?.dirPerson?.id && (
              <TypeSports id={id} readonly={!access.includes(2)} />
            )}
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'Organizations'}
          onChange={handleChangeAccordion('Organizations')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Организации</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, 'Organizations') && data?.dirTrainer?.dirPerson?.id && (
              <Organizations id={id} readonly={!access.includes(2)} />
            )}
          </AccordionDetails>
        </Accordion>

        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'Duplicates'}
          onChange={handleChangeAccordion('Duplicates')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Дубликаты</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {onExpand(expanded, 'Duplicates') && data?.dirTrainer?.dirPerson?.id && (
              <Duplicates id={data?.dirTrainer?.dirPerson?.id} />
            )}
          </AccordionDetails>
        </Accordion>
      </ContentWrapperWidget>
    </MainTemplate>
  );
};

export default Single;
